import { useState, useEffect } from "react";
import { Switch } from "@chakra-ui/react";
import useUpdateConfigFiltrosCulturas from "../../hooks/useUpdateConfigFiltrosCulturas"
import { showError } from "infra/helpers/alerta";
import { Container } from "./styles";

interface StatusProps {
  ocupacaoId: string;
  active: boolean;
}

function Status({ ocupacaoId, active }: StatusProps) {
  const [isActive, setIsActive] = useState(active);
  const { mutateAsync } = useUpdateConfigFiltrosCulturas();

  async function handleChange() {
    
    const response = await mutateAsync({ id: ocupacaoId, exibir: !isActive });
     if (response.status === 204) {
        setIsActive(!isActive);
        return;
      }

      const details = (response as any).response.data.Details;
      const error = details[0].Errors[0];
      showError(error);
  
  };

  useEffect(() => {
    setIsActive(active);
  }, [active]);

  return (
    <Container>
      <Switch 
        size="md" 
        colorScheme="green"
        isChecked={isActive}
        onChange={handleChange}
      />
    </Container>
  );
}

export default Status;